import React, { useState } from "react";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  LazyImage,
  TextStyled,
} from "../../../../components/styled/Elements";
import { ForgetPassImg } from "../../../../components/styled/AllImages";
import { Form, Modal } from "react-bootstrap";
import ValidatedInput from "../../../../components/common/inputFields/ValidatedInput";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { emailRegex } from "../../../../utils";
import AuthApi from "../../../../services/api/authApi";
import { toast } from "react-toastify";

const ForgetPasswordModal = (props) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [loading, setLoading] = useState(false);

  const onSubmit = async (email) => {
    try {
      setLoading(true);
      const response = await AuthApi.reqPasswordReset(email);
      if (response.code === 200) {
        toast.success(t('Email_has_been_sent'));
        props.onBtnClick();
      } 
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
    }
      
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box className="d-flex flex-column align-items-center py-3 px-2">
            <Box>
              <LazyImage src={ForgetPassImg} />
            </Box>
            <Box>
              <HeadingStyled size="24px" weight="bold" color="var(--text)">
                {t("forgot_password")}
              </HeadingStyled>
            </Box>
            <Box>
              <TextStyled
                size="16px"
                weight="500"
                color="var(--text)"
                className="text-center px-3"
              >
                {t("enter_email_below_to_get_reset_link")}
              </TextStyled>
            </Box>
            <Box className="w-100">
              <ValidatedInput
                name="email"
                label={"email"}
                type="input"
                fieldType="text"
                placeholder={"emailPlaceholder"}
                className={"w-100 mb-3 combined flex-wrap p-0"}
                bg="var(--white)"
                errors={errors}
                register={register}
                validationRules={{
                  required: true,
                  inline: true,
                  pattern: {
                    value: emailRegex,
                    message: "invalidEmail",
                  },
                }}
              />
            </Box>
            <ButtonStyled
              type="submit"
              className="w-100"
              clName="w-100"
              label={t("send")}
              isLoading={loading}
            />
          </Box>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ForgetPasswordModal;
